import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from 'react-icons-kit';
import { ic_mode_edit } from 'react-icons-kit/md/ic_mode_edit';
import { ic_more_horiz as menuIcon } from 'react-icons-kit/md/ic_more_horiz';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import ReactTooltip from 'react-tooltip';
import { getLockLabel } from '../../utils/CommonFunctions.js';

export default class EntryOptions extends Component {
    static propTypes = {
        entry: PropTypes.object.isRequired,
        onEditEntry: PropTypes.func.isRequired,
        onDuplicateEntry: PropTypes.func.isRequired,
        onToggleApproved: PropTypes.func.isRequired,
        onToggleBillable: PropTypes.func.isRequired,
        onDeletePressed: PropTypes.func.isRequired,
        onMessagePressed: PropTypes.func.isRequired,
        canApprove: PropTypes.bool.isRequired,
        canEdit: PropTypes.bool.isRequired,
        shouldShowBillable: PropTypes.bool.isRequired,
        noIntegration: PropTypes.bool.isRequired,
        accountStore: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.state = {
            isDropdownOpen: false,
        };
    }

    requestClose = () => {
        this.setState({
            isMessageModalOpen: false,
        });
    };

    handleToggleApprovePressed = () => {
        this.props.onToggleApproved(this.props.entry, this.props.noIntegration, true);
    };

    handleToggleBillablePressed = () => {
        this.props.onToggleBillable(this.props.entry);
    };

    handleEditPressed = () => {
        this.props.onEditEntry(this.props.entry);
    };

    handleDuplicatePressed = () => {
        this.props.onDuplicateEntry(this.props.entry);
    };

    handleToggleDropdownPressed = () => {
        this.setState({ isDropdownOpen: !this.state.isDropdownOpen });
    };

    render() {
        const isApproved = this.props.entry.approved === 'Yes';
        const isLocked = this.props.entry.locked === 'Yes';
        const isBillable = this.props.entry.billable === 'Yes';
        const {
            entry,
            canApprove,
            canEdit,
            shouldShowBillable,
            noIntegration,
            accountStore,
        } = this.props;
        const { isDropdownOpen } = this.state;

        return (
            <div className="entryOptionContainer">
                <ReactTooltip
                    id="entry-options-tooltip"
                    delayShow={300}
                    type="dark"
                    place="top"
                    effect="solid"
                    className="entry-options-tooltip"
                />

                {canEdit && (
                    <button
                        className="rowActionButton rowActionButtonWithIcon"
                        onClick={this.handleEditPressed}
                        data-tip="Edit entry details"
                        data-for="entry-options-tooltip"
                        aria-label="Edit entry details"
                    >
                        <Icon icon={ic_mode_edit} size={20} aria-hidden="true" />
                        Edit
                    </button>
                )}

                <Dropdown isOpen={isDropdownOpen} toggle={this.handleToggleDropdownPressed}>
                    <DropdownToggle
                        className="rowActionButton"
                        data-tip="More options"
                        data-for="entry-options-tooltip"
                        aria-label="More options - Duplicate, approve, billable, message, and delete actions"
                    >
                        <Icon size={20} icon={menuIcon} aria-hidden="true" />
                    </DropdownToggle>
                    <DropdownMenu right>
                        <DropdownItem onClick={this.handleDuplicatePressed}>Duplicate</DropdownItem>

                        {canEdit && canApprove && (
                            <DropdownItem onClick={this.handleToggleApprovePressed}>
                                {isApproved ? 'Mark as Pending' : 'Mark as Approved'}
                            </DropdownItem>
                        )}

                        {canEdit && shouldShowBillable && (
                            <DropdownItem onClick={this.handleToggleBillablePressed}>
                                {isBillable ? 'Mark as Not Billable' : 'Mark as Billable'}
                            </DropdownItem>
                        )}

                        {canEdit && noIntegration && isApproved && !isLocked && (
                            <DropdownItem onClick={this.handleToggleApprovePressed}>
                                {`Mark as ${getLockLabel(accountStore)}`}
                            </DropdownItem>
                        )}

                        <DropdownItem onClick={() => this.props.onMessagePressed(entry)}>
                            Send a Message
                        </DropdownItem>

                        {canEdit && <DropdownItem divider />}

                        {canEdit && (
                            <DropdownItem
                                onClick={() => this.props.onDeletePressed(entry)}
                                className="destructiveOption"
                            >
                                Delete
                            </DropdownItem>
                        )}
                    </DropdownMenu>
                </Dropdown>
            </div>
        );
    }
}
